/* Home Collection Section Height Set Logic */
var matchHeight = function(selector, sectionSelector) {
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  for (var i = 0; i < elements.length; i++) {
      elements[i].style.height = 'auto';
      if (elements[i].offsetHeight > maxHeight) {
          maxHeight = elements[i].offsetHeight;
      }
  }

  for (var i = 0; i < elements.length; i++) {
      elements[i].setAttribute('style', '--height-set: ' + maxHeight + 'px');
  }

  var sectionElements = document.querySelectorAll(sectionSelector);
  for (var j = 0; j < sectionElements.length; j++) {
      sectionElements[j].setAttribute('style', 'height: ' + maxHeight + 'px');
  }
};

window.onload = function() {
  matchHeight('.collection-list-wrapper .media-card__link .media', '.collection-list-wrapper .indicators');
};
window.onresize = function() {
  matchHeight('.collection-list-wrapper .media-card__link .media', '.collection-list-wrapper .indicators');
};
matchHeight('.collection-list-wrapper .media-card__link .media', '.collection-list-wrapper .indicators');